import "./App.css";
import ClientCards from "./components/ClientCards";
import RevenueChart from "./components/RevenueChart";
import TaskBoard from "./components/TaskBoard";
import AiEffectSummary from "./components/AiEffectSummary";
import { BrainCircuit, LayoutDashboard } from "lucide-react";

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <div className="header-inner">
          <div className="logo">
            <BrainCircuit size={28} color="#6366f1" />
            <span className="logo-text">AI Consulting Dashboard</span>
          </div>
          <div className="header-right">
            <LayoutDashboard size={16} color="#94a3b8" />
            <span className="header-date">2026年6月3日</span>
          </div>
        </div>
      </header>

      <main className="main-content">
        <AiEffectSummary />
        <RevenueChart />
        <ClientCards />
        <TaskBoard />
      </main>
    </div>
  );
}

export default App;
